import React from "react";
import * as utils from "./utils.jsx";

import { useBackendData, useFormState } from "./hooks.ts";

function AddMessageForm({ action, postMessage }) {
  const {
    value,
    setValue,
    error,
    errors,
    submitting,
    handleChange,
    handleSubmit,
  } = useFormState({
    action,
    handleSubmitted: handleSubmitted,
  });

  function handleSubmitted(data) {
    postMessage(data);
    setValue({});
  }

  return (
    <div className="module form subtle">
      <div className="container">
        <form>
          <fieldset className="row">
            <div className="col two">
              <h2>To:</h2>
            </div>
            <div className="col ten">Crew</div>
          </fieldset>

          <fieldset className="row">
            <div className="col two">
              <h2>Subject:</h2>
            </div>
            <div className="col ten">
              <utils.FormField
                type="text"
                name="subject"
                value={value.text}
                errors={errors}
                onChange={handleChange}
              />
            </div>
          </fieldset>
          <fieldset className="row">
            <div className="col two">
              <h2>Message:</h2>
            </div>
            <div className="col ten">
              <utils.FormField
                type="textarea"
                name="body"
                value={value.body}
                errors={errors}
                onChange={handleChange}
              />
            </div>
          </fieldset>
          <hr />
          <fieldset className="row">
            <div className="col two">&nbsp;</div>
            <div className="col two">
              <button
                className="ui button small"
                onClick={handleSubmit}
                disabled={submitting}
              >
                <span className="icon-comment"></span>{" "}
                {submitting ? "Posting..." : "Post"}
              </button>
              {error ? (
                <div className="validation-error">
                  <div className="container">{error}</div>
                </div>
              ) : (
                ""
              )}
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  );
}

function sanitize_user_input(s, trusted) {
  if (trusted == true) {
    return s;
  }
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\n/g, "<br />")
    .replace(/\b(https?:\/\/[^\s()]+)/g, '<a target="_blank" href="$1">$1</a>');
}

function Message({ data }) {
  const msg = data;
  return (
    <div className="item">
      <div className="row">
        <div className="col two">
          <img
            src={window.base_url + "static/images/avatar.01.png"}
            style={{ width: 80 }}
            alt="avatar.01"
          />
        </div>
        <div className="col ten">
          <h3>{msg.subject}</h3>
          <h4>
            <utils.DateRange start={msg.date_sent} showTime={false} />
          </h4>
          <p
            dangerouslySetInnerHTML={{
              __html: sanitize_user_input(msg.body_text, msg.html_message),
            }}
          />
        </div>
      </div>
    </div>
  );
}

function WorkPartyMessageBoard({ wp }) {
  const [messages, setMessages] = React.useState(null);
  useBackendData({
    url: wp.views.messages,
    afterLoad: (data) => {
      setMessages(data);
    },
  });
  const [showAddForm, setShowAddForm] = React.useState(false);
  const [info, setInfo] = React.useState(null);

  function postMessage(msg) {
    setMessages([msg, ...messages]);
    setShowAddForm(false);
    setInfo("Your message has been sent!");
  }

  function toggleNew() {
    setShowAddForm(!showAddForm);
  }

  var post_url = wp.actions.post;
  if (messages === null) {
    return <div className="container">Loading...</div>;
  }
  return (
    <div>
      <div className="module toolbar">
        <div>
          <h2>
            Crew Message Board ({messages.length} message
            {messages.length == 1 ? "" : "s"})
          </h2>
        </div>
        {post_url ? (
          <div>
            <button
              type="button"
              className="ui button small"
              onClick={toggleNew}
            >
              <span className="icon-edit"></span> New Message
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
      {showAddForm ? (
        <AddMessageForm action={post_url} postMessage={postMessage} />
      ) : (
        ""
      )}
      {info ? (
        <div className="info">
          <div className="container">{info}</div>
        </div>
      ) : (
        ""
      )}
      {messages.map((m, index) => (
        <Message key={index} data={m} />
      ))}
    </div>
  );
}

export default WorkPartyMessageBoard;
